<template>
  <div
    class="result-wrap"
    :class="{
      'result-wrap-none': themeType === THEME_TYPE_NONE,
      'result-wrap-normal': themeType === THEME_TYPE_COMMON,
      'result-wrap-party': themeType === THEME_TYPE_PARTY,
    }"
  >
    <!-- 自定义的背景 -->
    <div class="diy-bg"></div>

    <div class="rule">
      <!-- <Button @click="showLeaderBoard = true" class="btn">排名</Button> -->
    </div>
    <ResultPersonInfo v-if="showCommiter" color="#ffffff" />
    <div class="result animate__animated animate__flipInX">
      {{ resInfo?.score ? resInfo?.score : 0 }}
    </div>
    <div class="infos">
      <h1 class="infos-text">
        {{
          $route.query.isSuccess && $route.query.isSuccess === '1'
            ? '恭喜您，闯关成功！'
            : '闯关失败，再接再厉吧！'
        }}
      </h1>
      <div class="infos-detail animate__animated animate__fadeInDown">
        <div v-if="resInfo.score !== undefined" class="infos-detail-item">
          <div class="wrap3 normal">
            用时：{{
              resInfo.longTime
                ? `${(resInfo.longTime / 1000).toFixed(1)}s`
                : '--'
            }}
          </div>
          <div class="wrap3 normal">
            {{ resInfo.rowNum ? `第${resInfo.rowNum}名` : '暂无排名' }}
          </div>
          <div class="wrap3 normal">
            答对：{{ resInfo.rightCount ? resInfo.rightCount : 0 }}题
          </div>
          <div class="wrap3 grey">
            总时间：{{
              $store.getters.getQuesList.length *
              ($store.getters.getQuesSetting?.timeLimit
                ? $store.getters.getQuesSetting?.timeLimit
                : 30)
            }}s
          </div>
          <!-- <div class="wrap3 grey">参与：{{ resInfo.total }}人</div> -->
          <div class="wrap3 grey"></div>
          <div class="wrap3 grey">总共：{{ resInfo.totalCount }}题</div>
        </div>
      </div>
    </div>
    <div
      v-if="resInfo.lotteryUrl"
      class="lottery animate__animated animate__fadeIn"
    >
      <div class="content">
        <p class="text">恭喜您获得一次 抽奖机会！</p>
        <Button @click="handleLotteryClick" class="btn">试试手气</Button>
      </div>
    </div>
    <Button
      :class="{ hasLottery: !resInfo.lotteryUrl }"
      @click="handleJump2Home"
      class="finish-btn"
      >{{ $store.getters.getFinishBtnText }}</Button
    >
  </div>
  <!-- 排行榜 -->
  <ActionSheet v-model:show="showLeaderBoard">
    <div class="leaderboard-title">答题排行榜</div>
    <ul class="leaderboard-list">
      <li class="list-item">
        <div class="left">
          <div class="index">1</div>
          <div class="img"></div>
          <div class="info">
            <p class="name">辛迪拉</p>
            <p class="more">答对8题 共10题</p>
          </div>
        </div>
        <div class="right">85分</div>
      </li>
      <li class="list-item">
        <div class="left">
          <div class="index">1</div>
          <div class="img"></div>
          <div class="info">
            <p class="name">辛迪拉</p>
            <p class="more">答对8题 共10题</p>
          </div>
        </div>
        <div class="right">85分</div>
      </li>
      <li class="list-item">
        <div class="left">
          <div class="index">1</div>
          <div class="img"></div>
          <div class="info">
            <p class="name">辛迪拉</p>
            <p class="more">答对8题 共10题</p>
          </div>
        </div>
        <div class="right">85分</div>
      </li>
      <li class="list-item">
        <div class="left">
          <div class="index">1</div>
          <div class="img"></div>
          <div class="info">
            <p class="name">辛迪拉</p>
            <p class="more">答对8题 共10题</p>
          </div>
        </div>
        <div class="right">85分</div>
      </li>
    </ul>
  </ActionSheet>
  <!-- 证书弹窗 -->
  <CertificateDialog v-if="showCertificate" @close="showCertificate = false" />
</template>

<script setup>
import { Button, ActionSheet } from 'vant'
import { reactive, ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import qs from 'qs'
import { useCommonLotteryEffect } from '@/effects/lotteryClickEffect'
import { useCommonStyleEffect } from '@/effects/styleConfigEffect'
import ResultPersonInfo from '@/components/resultPersonInfo/index.vue'
import CertificateDialog from '@/components/certificateDialog/index.vue'
import { getQueryString } from '@/utils/tools'
import { useCommiterInfo, useCertificateDialog } from '@/hooks/index.js'
import { getResult } from '@/api'
import { THEME_TYPE_NONE, THEME_TYPE_COMMON, THEME_TYPE_PARTY } from '@/constants'

// 初始化配置
const optionEffect = () => {
  const store = useStore()
  const quesSetting = store.getters.getQuesSetting

  let showType = 'none'
  if (quesSetting.scoreShow === 2 && quesSetting.rankShow === 2) {
    showType = 'all'
  } else if (quesSetting.scoreShow === 2) {
    showType = 'score'
  } else if (quesSetting.rankShow === 2) {
    showType = 'rank'
  } else {
    showType = 'none'
  }

  return {
    showType,
  }
}

const route = useRoute()
const router = useRouter()
const store = useStore()
const resInfo = reactive({
  score: undefined,
  rank: undefined,
  rightCount: 0,
  lotteryUrl: '',
  rowNum: 0,
  total: 0,
  totalCount: 0,
})

let { showType } = optionEffect()
// 判断练习还是正式考试
const resultType = route.query.resultType
  ? parseInt(route.query.resultType)
  : 1

const isPreview = route.query.isPreview
  ? parseInt(route.query.isPreview)
  : 1

if (resultType === 2) {
  showType = 'score'
}

// 再次答题
const activeId = getQueryString('activeId')
const unitId = getQueryString('unitId')
const handleJump2Home = () => {
  router.replace(
    `/competition/home?questionActiveKey=${route.query.questionActiveKey}&isPreview=${isPreview}&activeId=${activeId}&unitId=${unitId}`
  )
}

// 主题样式
const themeType = computed(() => store.getters.getQuesSetting?.answerType)

// 抽奖点击
const { handleLotteryClick } = useCommonLotteryEffect(resInfo)

// 排行榜显示
const showLeaderBoard = ref(false)

const { showCommiter } = useCommiterInfo()

// 证书弹窗
const { showCertificate } = useCertificateDialog()

// 获取考试结果
const resultInfoEffect = (resInfo, resultType) => {
  const getResultInfo = async () => {
    const res = await getResult(
      qs.stringify({
        questionActiveKey: route.query.questionActiveKey,
        type: resultType,
        token: store.getters.getToken,
        answerGroupKey: route.query.answerGroupKey,
      })
    )
    resInfo.score = res.data.score
    resInfo.longTime = res.data.longTime
    resInfo.rank = res.data.rank
    resInfo.rightCount = res.data.rightCount
    resInfo.rowNum = res.data.rowNum
    resInfo.total = res.data.total
    resInfo.totalCount = res.data.totalCount
    resInfo.lotteryUrl = res.data.lotteryUrl
  }

  getResultInfo()

}

onMounted(() => {
  resultInfoEffect(resInfo, resultType)
})
</script>
<style lang="scss" scoped>
.result-wrap {
  width: 100%;
  min-height: 100vh;
}
.result-wrap-party {
  background: no-repeat top/100%
  url('../../assets/img/competition/home-bg-party.png');

  h1.infos-text,
  .infos .infos-detail .infos-detail-item div,
  .infos .infos-detail .infos-detail-item div.grey {
    color: #ffffff;
  }
  .infos .infos-detail {
    display: flex;
    align-items: center;
    height: 200px;
    background-color: rgba(187, 47, 41, 0.2);

    div.grey {
      border: none !important;
      opacity: 0.9 !important;
    }
  }

  .finish-btn {
    background: linear-gradient(0deg, #ff9c2e, #ffde3a);
    box-shadow: 0px 1px 10px 0px rgba(254, 167, 74, 0.57);
  }
}
.result-wrap-normal {
  background: no-repeat top/100%
  url('../../assets/img/competition/home-bg-normal.png');

  h1.infos-text,
  .infos .infos-detail .infos-detail-item div,
  .infos .infos-detail .infos-detail-item div.grey {
    color: #30afff;
  }
  .infos .infos-detail {
    display: flex;
    align-items: center;
    height: 200px;
    background-color: rgba(255, 255, 255, 0.5);
    background: hsla(0, 0%, 100%, 0.8);
    -webkit-backdrop-filter: blur(5px);
    backdrop-filter: blur(5px);
    border: 1px solid #fff;

    div.grey {
      border: none !important;
      opacity: 0.9 !important;

    }
  }
  .finish-btn {
    box-shadow: none;
    background: linear-gradient(265deg, #2b91ff, #1fbcff);
  }
}
.rule {
  text-align: right;
  padding-top: 40px;
  .btn {
    margin-top: 50px;
    margin-right: 40px;
    min-width: 118px;
    height: 48px;
    background: #f7fbfe;
    box-shadow: 0px 0px 10px 0px rgba(47, 117, 182, 0.1);
    opacity: 0.6;
    border-radius: 23px;
    font-size: 28px;
    color: #eb5046;
  }
}
.result {
  margin: 0 auto;
  width: 293px;
  height: 282px;
  line-height: 301px;
  text-align: center;
  background: no-repeat top/100%
  url('../../assets/img/competition/result-icon.png');
  font-size: 72px;
  font-weight: bold;
  color: #ffffff;

  .none-img {
    position: relative;
    top: 15px;
    width: 105px;
    height: 113px;
  }
}
.infos {
  margin: 0 auto;
  margin-top: 40px;

  .infos-text {
    text-align: center;
    margin: 0;
    font-size: 36px;
    color: #ffffff;
  }

  .infos-detail {
    margin: 0 auto;
    margin-top: 27px;
    width: 650px;
    height: 187px;
    text-align: center;
    background-color: #f8f9fa;
    .infos-detail-item {
      display: flex;
      flex-wrap: wrap;
      font-size: 32px;
      font-weight: 500;

      div {
        color: #333;
        height: 84px;
        line-height: 84px;
      }
      div.grey {
        color: #999999;
        border-top: 1px solid #ebedf0;
        opacity: 0.8;
      }

      .wrap1 {
        width: 100%;
      }
      .wrap2 {
        width: 50%;
      }
      .wrap3 {
        width: 33.3%;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}

.lottery {
  margin-left: 106px;
  margin-top: 38px;
  width: 583px;
  height: 484px;
  background: no-repeat top/100%
  url('../../assets/img/competition/result-lottery.png');

  .content {
    margin-left: 149px;
    width: 253px;
    .text {
      margin: 0;
      text-align: center;
      padding-top: 226px;
      font-size: 34px;
      line-height: 1.2;
      font-weight: bold;
      color: #222222;
    }
    .btn {
      margin-top: 41px;
      width: 253px;
      height: 63px;
      background: linear-gradient(0deg, #ff615d, #fe4342);
      border-radius: 31px;
      font-size: 32px;
      color: #ffffff;
    }
  }
}

.finish-btn {
  display: block;
  margin: 0 auto;
  margin-top: 55px;
  width: 433px;
  height: 111px;
  background: linear-gradient(265deg, #2b91ff, #1fbcff);
  border-radius: 56px;
  border: none;
  font-size: 44px;
  font-weight: bold;
  color: #ffffff;
}

.hasLottery {
  margin-top: 400px;
}

// 排行榜
.leaderboard-title {
  position: absolute;
  margin: 0 auto;
  top: -45px;
  left: 0;
  right: 0;
  width: 503px;
  height: 96px;
  line-height: 96px;
  background: no-repeat center/100%
  url('../../assets/img/competition/leaderboard.png');
  color: #fff;
  font-size: 36px;
  text-align: center;
}
.leaderboard-list {
  margin-left: 39px;
  margin-right: 49px;
  margin-top: 40px;
  padding-bottom: 20px;
  .list-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    height: 148px;
    padding: 42px 0 39px 0;
    border-bottom: 1px solid rgba(0, 130, 251, 0.2);

    .left {
      display: flex;
      align-items: center;
      height: 100%;
      .index {
        font-size: 36px;
        color: #2897ff;
      }
      .img {
        margin-left: 40px;
        width: 75px;
        height: 75px;
        border-radius: 50%;
        background-color: #ccc;
      }
      .info {
        margin-left: 41px;
        p {
          margin: 0;
        }
        .name {
          margin-bottom: 14px;
          font-size: 34px;
          font-weight: 400;
          color: #333333;
        }
        .more {
          font-size: 26px;
          font-weight: 400;
          color: #999999;
        }
      }
    }
    .right {
      font-size: 36px;
      font-weight: 400;
      color: #1382ff;
    }
  }
}
</style>
<style>
.van-action-sheet,
.van-popup {
  overflow: visible !important;
}
</style>
